import * as React from 'react'
import { Elements } from '@tfo/common'
import { useIntl } from 'react-intl'
import { observer } from 'mobx-react'
import { useStore } from '../../hooks/useStore'
import CheckIcon from '@material-ui/icons/Check';
import './ForgotCreatePasswordComplete.scss'

const { Paragraph } = Elements

export const ForgotCreatePasswordComplete = observer(() => {
    const { forgotCreatePasswordController: store } = useStore()
    const intl = useIntl()

    return (
        <div className='forgot-create-password-complete-inner'>
            <div className='check-icon-wrapper'> <CheckIcon /></div>
            <div className='forgot-create-password-complete-text-body'>
                <Paragraph>{intl.formatMessage({
                    id: 'forgot-create-password-complete.confirmation1'
                },
                    {
                        email: <b>{store.email}</b>
                    }
                )}</Paragraph>
                <Paragraph>{intl.formatMessage({
                    id: 'forgot-create-password-complete.confirmation2'
                },

                )}</Paragraph>
            </div>
            <div className='forgot-create-password-subtext-wrapper'>
                <Paragraph small className='forgot-create-password-subtext'>
                    {intl.formatMessage({
                        id: 'forgot-create-password-complete.subText'
                    },
                        {
                            link: (
                                <span onClick={() => store.showForgotCreatePasswordComplete = false} className='forgot-create-password-link'>
                                    {intl.formatMessage({
                                        id: 'forgot-create-password.linkText'
                                    })}
                                </span>
                            )
                        }
                    )}
                </Paragraph>
            </div>
        </div>
    )
})